module.exports = __webpack_public_path__ + "img/apply_buy_1.3e88514c.png";